export default __webpack_public_path__ + "static/media/top-ten-block-2.1b054e14.svg";